export const BRAND_NAME = "Steimfit"

export const BRAND_TAGLINE = "Treinamento personalizado"

export const BRAND_DESCRIPTION =
  "Steimfit · plataforma de treinamento personalizado para coaches e alunos."
